<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HDnzXl/tc-custom/9780544381025.jpg?1734332833342" alt="This image is the cover for the book I'd Walk with My Friends If I Could Find Them"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I'd Walk with My Friends If I Could Find Them
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A “powerful” novel of young soldiers in Afghanistan and on the home front (<i>Esquire</i>).</b><br/>  <br/> A Florida Book Awards Gold Medalist<br/>  <br/> Longlisted for the Flaherty-Dunnan First Novel Prize<br/>  <br/> Winner of the Military Writers Association of America Bronze Medal<br/>  <br/> Wintric Ellis joins the army as soon as he graduates from high school, saying goodbye to his girlfriend, Kristen, and to the backwoods California town whose borders have always been the limits of his horizon. Deployed for two years in Afghanistan in a directionless war, he struggles to find his bearings in a place where allies could at any second turn out to be foes.<br/>  <br/> Two career soldiers, Dax and Torres, take Wintric under their wing. Together, these three men will face an impossible choice: risk death or commit a harrowing act of war.<br/>  <br/> The aftershocks echo long after each returns home to a transfigured world, where a veteran’s own children may fear to touch him and his nightmares still hold sway. Moving backward and forward in time to track these unforgettable characters from childhood to parenthood, from redwood forests to open desert roads to the streets of Kabul, <i>I’d Walk with My Friends If I Could Find Them</i> is a work of disarming eloquence and heart-wrenching wisdom from “one of the very rare authors who writes with authoritative insight into the warfare of the twenty-first century” (Robert Olen Butler).<br/>  <br/> “Bracing, riveting.” —Siobhan Fallon, author of <i>You Know When the Men Are Gone</i><br/>  <br/> “Add Jesse Goolsby to the list of promising military-experienced writers including Phil Klay.” —<i>Military Times</i><br/>  <br/> “One of the best works of literature to come from these wars.” —<i>storySouth</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jesse Goolsby
      </h2>
      
      <p class="authorDescription body article">Jesse Goolsby&#160;is an Air Force officer and the author of the novel <I>I&#39;d Walk with My Friends If I Could Find Them</I>. His fiction and essays have appeared in <I>Narrative</I>, <I>Epoch,</I> the <I>Literary Review,</I><I>Alaska Quarterly Review,</I> the <I>Greensboro Review,</I> and other publications. He is the recipient of the Richard Bausch Fiction Prize, the John Gardner Memorial Award in Fiction, and a Holland &amp; Knight Distinguished Fellowship from the Hambidge Center for the Creative Arts. He has earned honorable mentions in both <I>The Best American Essays</I> and <I>The Best American Short Stories</I>, and his work has been included in <I>The Best American Mystery Stories</I>. Goolsby was raised in Chester, California, and now lives in Tallahassee, Florida.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24d03f08